// extracted by mini-css-extract-plugin
module.exports = {"posts":"Feed_posts__17WuR","my_posts":"Feed_my_posts__2mYNI"};